/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Services_Map_LabelInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Map of the {countText} port where we have attended vessels" |
* | * | "Map of the {countText} ports where we have attended vessels" |
*
* @param {Services_Map_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_map_label = /** @type {((inputs: Services_Map_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Map_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") {
		const countText = registry.number("zh", i?.count, {}, true);
		return /** @type {LocalizedString} */ (`我们曾登轮服务的 ${countText} 个港口地图`)
	}
	{
		const countPlural = registry.plural("en", i?.count, {}, true);
		const countText = registry.number("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`Map of the ${countText} port where we have attended vessels`);
		return /** @type {LocalizedString} */ (`Map of the ${countText} ports where we have attended vessels`)
	}
});